<template>
  <transition name="fade" mode="out-in">
    <div class="modal contents" v-if="isShow">
      <div class="modal__bg"></div>

      <div class="modal__content" :class="s.modal" :style="{ width: modalWidth }">
        <!-- modalNameに応じて表示するコンポーネントを変化 -->
        <div :class="s.title_wrap">
          <div :class="s.title">{{ contents.modalTitle }}</div>
          <div
            @click="hideModal"
            v-if="showCloseBtn"
            :class="s.close"><i class="fa-solid fa-xmark"></i>
          </div>
        </div>
        <div :class="s.content">
          <component v-bind:is="contents.modalName" v-bind:data="contents.data" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';
// モーダルコンポーネントの登録
import OrderResult from './contents/OrderResult.vue';
import MessageTemplate from './contents/MessageTemplate.vue';
import ChatHistory from './contents/ChatHistory.vue';
import DemandOrderResult from './contents/DemandOrderResult.vue';
import PassengerResults from './contents/PassengerResults.vue';
import EditDemandBreak from './contents/EditDemandBreak.vue';
import DriverDailyCheck from './contents/DriverDailyCheck.vue';
import CustomerInfo from './contents/CustomerInfo.vue';
import ThreadMessages from './contents/ThreadMessages.vue';
import TalkroomMessages from './contents/TalkroomMessages.vue';
import DispatchAdditionals from './contents/DispatchAdditionals.vue';


export default {
  name: 'ContentsModal',
  components: {
    OrderResult,
    MessageTemplate,
    ChatHistory,
    DemandOrderResult,
    PassengerResults,
    EditDemandBreak,
    DriverDailyCheck,
    CustomerInfo,
    ThreadMessages,
    TalkroomMessages,
    DispatchAdditionals,
  },
  data() {
    return {
      showHideBtnsModal: ['ChatHistory'],
      hideCloseBtnModal: ['DriverDailyCheck'],
    };
  },
  computed: {
    ...mapState('modal', ['contents']),
    isShow() {
      return this.contents.modalName !== '';
    },
    modalWidth() {
      if (this.contents.modalWidth) {
        return this.contents.modalWidth;
      }
      return '80%';
    },
    showCloseBtn() {
      return !this.hideCloseBtnModal.includes(this.contents.modalName);
    },
  },
  methods: {
    hideModal(args = null) {
      this.$store.dispatch('modal/contents/hideModal', args, { root: true });
    },
  },
};
</script>

<style lang="scss" module="s">
.modal {
  min-width: min(390px, 90%);
}
.close {
  margin-right: 8px;
  cursor: pointer;
  transition: all .3s;
  &:hover {
    opacity: .5;
  }
}
.title {
  &_wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--bg-gray);
    padding: 12px 20px;
    border-bottom: 1px solid var(--border-gray);
  }
  width: 100%;
  font-weight: bold;
}
.content {
  padding: 1em 2em;
  max-height: 80vh;
}
</style>
